// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-mXt","newExpiryDate":"styles_newExpiryDate__27EAK","footer":"styles_footer__2KBFL"};